import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useSettings } from "@/lib/useSettings";
import { eur } from "@/lib/workflow";

export function PaidDialog({ doc, onClose, onDone }) {
  const { data: settings } = useSettings();
  const banks = (settings?.accounting?.banks || []).map((b) => b.name).filter(Boolean);
  const [date, setDate] = useState("");
  const [bank, setBank] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (doc) { setDate(new Date().toISOString().slice(0, 10)); setBank(banks[0] || ""); setNote(""); }
  }, [doc]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    if (!date) { toast.error("Bitte das Zahlungsdatum eintragen"); return; }
    setBusy(true);
    try {
      await api.put(`/documents/${doc.id}/status`, { status: "bezahlt", paid_date: date, paid_bank: bank, paid_note: note });
      toast.success(`Rechnung ${doc.number} als bezahlt erfasst`);
      onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="paid-dialog">
        <DialogHeader><DialogTitle>Zahlungseingang erfassen</DialogTitle></DialogHeader>
        {doc && <div className="text-sm text-slate-600">Rechnung <b>{doc.number}</b> · {doc.customer_name} · <b>{eur(doc.gross)}</b> brutto</div>}
        <div className="space-y-3">
          <div><Label>Zahlungsdatum</Label><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1 w-48" data-testid="paid-date" /></div>
          <div>
            <Label>Eingegangen auf</Label>
            <select value={bank} onChange={(e) => setBank(e.target.value)} className="mt-1 h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm" data-testid="paid-bank">
              {banks.map((b) => <option key={b} value={b}>{b}</option>)}
              <option value="Bar">Bar</option>
              <option value="Sonstiges">Sonstiges</option>
            </select>
          </div>
          <div><Label>Notiz (optional)</Label><Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="z. B. Teilzahlung, Verwendungszweck" className="mt-1" data-testid="paid-note" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="paid-cancel">Abbrechen</Button>
          <Button disabled={busy} onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="paid-save">Als bezahlt speichern</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
